import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Small, StyledLink } from "orcs-design-system";
import { isNil } from "lodash";
import numeral from "numeral";

const ViewMoreResults = ({
  foundCount,
  totalCount,
  matchCount,
  viewMoreURL,
  onLoadMore,
  compact = false,
}) => {
  // cap just in case (used to be an issue - no longer)
  const cappedCount = Math.min(foundCount, totalCount);
  const foundStr = numeral(cappedCount).format("0,0");
  const totalStr = numeral(totalCount).format("0,0");
  const allLoaded = cappedCount >= totalCount;

  const loadMoreEle = useMemo(() => {
    const haveMore = totalCount > foundCount;

    // Current app path (no origin, no query params)
    const currentPath = window.location.pathname;
    const viewingMore = viewMoreURL === currentPath;

    if (haveMore) {
      if (viewingMore && onLoadMore) {
        return (
          <StyledLink onClick={onLoadMore} fontSize="1">
            Load more results
          </StyledLink>
        );
      }
      if (viewMoreURL) {
        return (
          <StyledLink to={viewMoreURL} fontSize="1">
            View more results
          </StyledLink>
        );
      }
    }
    return null;
  }, [totalCount, foundCount, viewMoreURL, onLoadMore]);

  const summary = isNil(matchCount) ? (
    <>
      Showing {foundStr} of {totalStr} results.
    </>
  ) : (
    <>
      Showing {numeral(matchCount).format("0,0")}{" "}
      {matchCount === 1 ? "match" : "matches"}. Filtered from{" "}
      {allLoaded ? totalStr : `${foundStr} of ${totalStr}`} results.
    </>
  );

  return (
    <Box p="r" bg="transparent" style={{ textAlign: "center" }}>
      <Small display="block">
        {summary}
        {compact ? " " : <br />}
        {loadMoreEle}
      </Small>
    </Box>
  );
};

ViewMoreResults.propTypes = {
  foundCount: PropTypes.number,
  totalCount: PropTypes.number,
  matchCount: PropTypes.number,
  viewMoreURL: PropTypes.string,
  onLoadMore: PropTypes.func,
  compact: PropTypes.bool,
};

export default ViewMoreResults;
